import { useProfileSectionData } from "@/hooks";

type PersonalData = {
  personalDetailSection?: {
    personalDetails: {
      profileVisibility: boolean;
    };
  };
};
export const getPersonal = () => {
  return useProfileSectionData<PersonalData>("personalDetailSection");
};
